import { render, staticRenderFns } from "./HomeStats.vue?vue&type=template&id=7a4e40dd&scoped=true&"
import script from "./HomeStats.vue?vue&type=script&lang=ts&"
export * from "./HomeStats.vue?vue&type=script&lang=ts&"
import style0 from "./HomeStats.vue?vue&type=style&index=0&id=7a4e40dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4e40dd",
  null
  
)

/* custom blocks */
import block0 from "./HomeStats.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VIcon,VRow})
